import { z } from "zod";
import { EnreinArtifactUriSchema } from "./artifact-uri.js";
/** storage-path-map.v1.0 — physical path maps to logical URI (D-019). */
export const StoragePathMapV1Schema = z
    .object({
    schemaVersion: z.literal("storage-path-map.v1.0"),
    artifactUri: EnreinArtifactUriSchema,
    storageProvider: z.enum(["r2", "s3", "local"]).optional(),
    physicalPath: z.string().min(1),
    contentType: z.string().optional(),
})
    .strict();
//# sourceMappingURL=storage-path-map.js.map